module.exports = __webpack_public_path__ + "static/Face-Sean.813d1174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Sean.jpg
// module id = 491
// module chunks = 144251824217401